/**
 * z-index for the `ContextualModal` component
 */
export const contextualModalZIndex = 1000;

/**
 * z-index for the modal overlay used by the contextual modal to block click
 * events on the application.
 */
export const modalOverlayZIndex = contextualModalZIndex - 1;

export const notificationToastZIndex = contextualModalZIndex + 1;

/**
 * Default z-index for kendo popup menus
 */
export const kendoPopupZIndex = contextualModalZIndex + 2;

/**
 * Export the height of the nav bar to be used by various elements for the tree
 * so that it perfectly matches on top of the nav bar
 */
export const navBarHeight = 60;
